import React from "react";

const Footer = () => {
	return (
		<div className="footer-area">
			<div className="container">
				<div className="footer-content">
					<div className="content-sub">
						<h2>Grazie</h2>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
